import { r as registerInstance, h } from './index-2b2e631a.js';
import { s as state } from './state-3cc1e9a3.js';
import { i as injectHistory } from './injectHistory-7dc9437f.js';
import './active-router-fda13bb6.js';

const searchSuggestionsDropdownCss = ":host{display:block}";

let SearchSuggestionsDropdown = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  /**
   * On suggestion click, update the router and search
   *
   * @param {any} event
   */
  onClick(event) {
    // Prevent default
    event.preventDefault();
    // Trigger input focus
    state.searchInputFocus = false;
    // Update query on state
    state.query = event.target.dataset.suggestion;
    // Determine if search form is set in state
    if (state.formElement) {
      // Submit search form
      state.formElement.submit();
    }
  }
  /**
   * On suggestion mousedown, prevent default to stop the search input blur event
   *
   * @param {any} event
   */
  onMouseDown(event) {
    // Prevent default
    event.preventDefault();
  }
  /**
   * Render element
   */
  render() {
    // Determine if there are some search suggestions
    if (state.searchSuggestions.length > 0) {
      // Return element
      return (h("ul", { class: "search-suggestions-dropdown", role: "listbox", "aria-label": "Search Suggestions", "aria-busy": state.loadingSuggestions, "aria-live": "polite", tabindex: "0" }, state.searchSuggestions.map((searchSuggestion, searchSuggestionIndex) => {
        // Determine aria attributes for accessibility
        const ariaSelected = (state.selectedSearchSuggestion === (searchSuggestionIndex + 1));
        // Return suggestion
        return (h("li", { "aria-selected": ariaSelected, id: `result-${(searchSuggestionIndex + 1)}`, "data-option-value": (searchSuggestionIndex + 1), "data-suggestion": searchSuggestion, key: searchSuggestion, onClick: this.onClick.bind(this), onMouseDown: this.onMouseDown.bind(this), role: "option" }, searchSuggestion));
      })));
    }
  }
};
injectHistory(SearchSuggestionsDropdown);
SearchSuggestionsDropdown.style = searchSuggestionsDropdownCss;

export { SearchSuggestionsDropdown as search_suggestions_dropdown };
